import axios from 'axios';
import * as _ from 'lodash';

import {
    IDiffProjectsResponse,
    IDiffProjectsData
} from 'src/models';

import DiffProjects from 'src/components/DiffProjects/DiffProjects';

import auditService from 'src/services/audit.service';
import projectService from 'src/services/project.service';

export default {
    diffProjectsComponent: null,

    dispose() {
        if (this.diffProjectsComponent) {
            this.diffProjectsComponent.dispose();
        }
        this.diffProjectsComponent = null;
    },

    show(auditId: string,
         secretProjectsPuids?: string[] // 保密项目的puid（变更列表中，保密项目增加小锁icon标识）
        ) {
        if (!this.diffProjectsComponent) {
            this.diffProjectsComponent = new DiffProjects({
                source: '<x-diff-projects></x-diff-projects>'
            });
            this.diffProjectsComponent.attach(document.getElementById('app'));
        }
        this.diffProjectsComponent.show(auditId, secretProjectsPuids)
    },

    // 获取项目变更单变化（变更、追加）的项目信息
    getDiffProjectsData(auditId: string): Promise<IDiffProjectsData> {
        return Promise.all([
            axios.get<IDiffProjectsResponse>(`/api/audits/${auditId}/diff-changes`).then(res => res.data),
            auditService.getChangeAuditOriginalProjectsAndProjects(auditId, true)
        ]).then(results => {
            const diffProjectResponse = results[0];
            const changeAuditOriginalProjectsAndProjects = results[1];

            // 变更的项目信息
            const updateListGroup = _.groupBy(diffProjectResponse.update_list, 'id');
            const updateProjectInfos = [];
            _.forEach(updateListGroup, (value, key) => {
                const info = {
                    puid: key,
                    title: value[0].prefix,
                    diffItems: value
                };
                updateProjectInfos.push(info);
            });

            // 追加的项目信息
            const addProjects = _.filter(changeAuditOriginalProjectsAndProjects.projects, project => projectService.getProjectIsNewSync(project));

            return {
                updateProjectInfos,
                addProjects
            };
        });
    }
};
